import { render, staticRenderFns } from "./McpPanel.vue?vue&type=template&id=98128bb2&scoped=true&"
import script from "./McpPanel.vue?vue&type=script&lang=js&"
export * from "./McpPanel.vue?vue&type=script&lang=js&"
import style0 from "./McpPanel.vue?vue&type=style&index=0&id=98128bb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98128bb2",
  null
  
)

export default component.exports